import { LitElement, html, css } from '@hh/global.js'

class HHBadgeWrapper extends LitElement {
  static properties = {
    key: {},
    text: { type: String },
    textColor: {
      type: String,
      attribute: 'text-color',
    },
    backgroundColor: {
      type: String,
      attribute: 'background-color',
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    if (this.textColor) {
      this.setTextColor(this.textColor)
    }
    if (this.backgroundColor) {
      this.setBackgroundColor(this.backgroundColor)
    }
  }

  setTextColor(color) {
    if (!color) return
    this.style.setProperty('--hh-color', color)
  }

  setBackgroundColor(color) {
    if (!color) return
    this.style.setProperty('--hh-background', color)
  }

  render() {
    return html`<span class="badge"><slot></slot></span>`
  }

  static styles = css`
    .badge {
      border-radius: 10rem;
      display: inline-block;
      font: var(--hh-body-bold-xxs-font);
      padding: 0.2rem 0.8rem;
      text-align: center;
      background-color: var(--hh-background, black);
      color: var(--hh-color, white);
      word-break: break-word;
      text-transform: uppercase;
    }

    @media screen and (min-width: 1024px) {
      .badge {
        font: var(--hh-body-bold-xs-font);
      }
    }
  `
}

if (!customElements.get('hh-badge-wrapper')) {
  customElements.define('hh-badge-wrapper', HHBadgeWrapper);
}